import {IAutoHealingReplacement, IReviewContent, IContentMarkerReview} from '../../components/Interface/View/IAutoHealingView'
import {IApiResponseState} from '../../components/Interface/IApiResponseState'
import { GetRadioSelectedAction } from './PowerDataQuery'


export type CLEAR_API_RESPONSE_STATUS = 'CLEAR_API_RESPONSE_STATUS'
export const CLEAR_API_RESPONSE_STATUS: CLEAR_API_RESPONSE_STATUS = 'CLEAR_API_RESPONSE_STATUS'
export type ClearApiResponseStatusAction = {
  type: CLEAR_API_RESPONSE_STATUS
}

export type SHOW_API_SUCCESS = 'SHOW_API_SUCCESS'
export const SHOW_API_SUCCESS: SHOW_API_SUCCESS = 'SHOW_API_SUCCESS'
export type ShowApiSuccessAction = {
  type: SHOW_API_SUCCESS
}

export type SHOW_API_ERROR = 'SHOW_API_ERROR'
export const SHOW_API_ERROR: SHOW_API_ERROR = 'SHOW_API_ERROR'
export type ShowApiErrorAction = {
  type: SHOW_API_ERROR
  apiResponseState: IApiResponseState
}

export type GET_REVIEWCONTENT = 'GET_REVIEWCONTENT'
export const GET_REVIEWCONTENT: GET_REVIEWCONTENT = 'GET_REVIEWCONTENT'
export type GetReviewContentAction = {
  type: GET_REVIEWCONTENT,
  reviewContent: IReviewContent
}

export type GET_REVIEWCONTENTMARKER = 'GET_REVIEWCONTENTMARKER'
export const GET_REVIEWCONTENTMARKER: GET_REVIEWCONTENTMARKER = 'GET_REVIEWCONTENTMARKER'
export type GetReviewContentMarkerAction = {
  type: GET_REVIEWCONTENTMARKER,
  reviewContentMarker: IContentMarkerReview
}

export type GET_REPLACECONTENT = 'GET_REPLACECONTENT'
export const GET_REPLACECONTENT: GET_REPLACECONTENT = 'GET_REPLACECONTENT'
export type GetReplaceContentAction = {
    type: GET_REPLACECONTENT,
    replaceContent: IAutoHealingReplacement
}

export type APPROVE_REVIEWCONTENT = 'APPROVE_REVIEWCONTENT'
export const APPROVE_REVIEWCONTENT: APPROVE_REVIEWCONTENT = 'APPROVE_REVIEWCONTENT'
export type ApproveReviewContentAction = {
  type: APPROVE_REVIEWCONTENT
}

export type GET_RADIOSELECTED = 'GET_RADIOSELECTED';
export const GET_RADIOSELECTED: GET_RADIOSELECTED = 'GET_RADIOSELECTED';
export interface GetRadioSelectedAction {
  type: GET_RADIOSELECTED;
  radioSelected: string;
}